import { partition, includes, prop } from 'ramda'

import { FieldConfig } from 'App/duck/types'

import { NAME_FIELDS } from '../constants'

export const partitionByNameFields = partition((field: FieldConfig) =>
  includes(prop('attribute', field), NAME_FIELDS),
)
